import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/sq'
import 'moment/locale/en-gb'
import { PercentageIndicator } from '@vfgroup-oneplatform/foundation/Components'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../VfText'

import styles from './ProgressBar.Styles'

function ProgressBar(props) {
  const {
    usedData,
    limit,
    description,
    isLoading,
    isContentLoading,
    loadingBackgroundColor,
    loadingForegroundColor,
    style,
  } = props

  // const error = usedData >= limit
  let percent = 0,
    animate = false

  if (`${usedData}` && `${limit}`) {
    if (!isNaN(usedData) && !isNaN(limit)) {
      percent = ((usedData * 100) / limit)
      animate = true
    }
  }

  if (!`${usedData}` || !`${limit}`) {
    return null
  }

  return (
    <View style={[styles.container, style]}>
      <View style={styles.datesContainer}>
        <VfText
          size="body"
          weight="bold"
          align="left"
          i18nKey={description}
          isLoading={isLoading}
          style={styles.text}
          loadingBackgroundColor={loadingBackgroundColor}
          loadingForegroundColor={loadingForegroundColor}
        />
        <VfText
          size="body"
          weight="regular"
          align="right"
          color={usedData <= 10 ? Colors.error : Colors.dark_grey}
          i18nKey={usedData <= 0 ? 'quiz_game_oot_question' : 'quiz_game_timer'}
          placeHolders={[usedData.toString()]}
          style={styles.text}
          isLoading={isContentLoading}
          loadingBackgroundColor={loadingBackgroundColor}
          loadingForegroundColor={loadingForegroundColor}
        />
      </View>
      <PercentageIndicator
        value={percent}
        fillColor={Colors.veryLightPinkTwo}
        color={Colors.vfRed}
        containerStyle={styles.percentageIndicator}
        animate={animate}
      />
      {/* {error ? <VfText
        i18nKey={desc || ''}
        size="footnote"
        color={Colors.vfRed}
        style={styles.desc}
      /> : null} */}
    </View>
  )
}

ProgressBar.defaultProps = {
  loadingBackgroundColor: '#f3f3f3',
  loadingForegroundColor: '#ecebeb',
}

ProgressBar.propTypes = {
  usedData: PropTypes.number,
  limit: PropTypes.number,
  type: PropTypes.string,
  description: PropTypes.string,
  isLoading: PropTypes.bool,
  isContentLoading: PropTypes.bool,
  loadingBackgroundColor: PropTypes.string,
  loadingForegroundColor: PropTypes.string,
  desc: PropTypes.string,
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
}

export default ProgressBar
